import { BackGroundLupaImg, Card, Container, LeftHalf } from "./styles";
import { Page } from "../../../../components/page-base";
import theme from "../../../../styles/theme";
import backgroundImg from "../../../../assets/images/icon-lupa.png";
import { cn } from "@/lib/utils";
import { ICustomPlan } from "../../models";

interface ICreditCard {
  numberOfQueries: number;
  price: number;
  customPlan?: ICustomPlan | null;
  leftColor: string;
  colorTitle: string;
  colorBody: string;
  backGroundColor: string;
  borderCustomer?: boolean;
  className?: string; // Adicionado
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const NewCreditCard: React.FC<ICreditCard> = ({
  className,
  colorTitle,
  colorBody,
  leftColor,
  borderCustomer,
  backGroundColor,
  numberOfQueries,
  price,
  customPlan,
  onClick,
}) => {
  return (
    <Container className={className} onClick={onClick}>
      <Card
        colorTitle={colorTitle}
        colorBody={colorBody}
        className={cn(
          "w-[130px] h-[130px] desktop:w-[170px] desktop:h-[170px] hover:brightness-90 cursor-pointer",
          {
            "!w-[400px] mobile:!w-[200px]": !!customPlan,
          }
        )}
        backGroundColor={backGroundColor}
        borderCustomer={borderCustomer || false}
      >
        <BackGroundLupaImg backgroundImage={backgroundImg} />
        <LeftHalf leftColor={leftColor} />
        <div className="relative z-20 flex flex-col justify-between items-center h-full">
          <h1
            className={cn(
              "text-[20px] laptop:text-[16px] text-nowrap text-white mt-10 mobile:mt-5 laptop:mt-8",
              {
                "mobile:text-[20px] text-wrap mx-2 mt-6 mobile:mt-2": numberOfQueries > 74 && !customPlan,
              }
            )}
          >
            {numberOfQueries === 1
              ? "01 CONSULTA"
              : numberOfQueries <= 74 && !customPlan
              ? `${numberOfQueries} CONSULTAS`
              : `A PARTIR DE ${customPlan?.minCredits || 75} CONSULTAS`}
          </h1>
          <div className="mb-6">
            <p className="text-[36px] laptop:text-[28px] -mb-4">R${price},00</p>
            <span className="desktop:text-[22px] text-[16px]">
              {numberOfQueries === 1 ? "(AVULSA)" : "(CADA)"}
            </span>
          </div>
        </div>
      </Card>
      <Page.Button
        className="mobile:!hidden"
        borderColor={theme.colors.palete.gold}
        hoverBgcolor={theme.colors.palete.brownDark}
        label="Comprar agora"
      />
    </Container>
  );
};
